import React from 'react';
import { KeywordsCarousel } from './KeywordsCarousel';
import { Connect, PropsFromRedux } from './KeywordsCarouselWizardContainer';

type Props = PropsFromRedux;

export function RawKeywordsCarouselWizard({
  queryKey,
  selectedKeywords,
  recommendedKeywords,
  selectKeyword,
  unSelectKeyword,
}: Props) {
  if (recommendedKeywords.length === 0 && selectedKeywords.length === 0) {
    return null;
  }

  return (
    <KeywordsCarousel
      queryKey={queryKey}
      recommendedKeywords={recommendedKeywords}
      selectedKeywords={selectedKeywords}
      selectKeyword={selectKeyword}
      unSelectKeyword={unSelectKeyword}
    />
  );
}

export const KeywordsCarouselWizard = Connect(RawKeywordsCarouselWizard);
